module.exports = __webpack_public_path__ + "img/pos_trung_bay.514ef4ed.png";